import parseISODuration from '@/helpers/parseISODuration.js'
import formatDuration from 'date-fns/formatDuration'
import { pipe, allPass, prop, ifElse, always } from 'ramda'
import { propIsTruthy } from '@v/util/briqRamdaExt.js'

const getDefaultTimeslotDuration = pipe(
  prop('DefaultTimeslotDuration'),
  parseISODuration,
  formatDuration,
)
const shouldParse = allPass([prop('ShowOnScheduler'), propIsTruthy('DefaultTimeslotDuration')])
export const parseDefaultTimeslotDuration = ifElse(
  shouldParse,
  getDefaultTimeslotDuration,
  always('-'),
)

const parseBoolean = value => {
  return value ? 'Yes' : 'No'
}

const doIfScheduled = f => ifElse(prop('ShowOnScheduler'), f, always('-'))

export const propIfScheduled = x => doIfScheduled(prop(x))

export const paseBoolIfScheduled = x => doIfScheduled(pipe(prop(x), parseBoolean))
